<template>
    <!-- 用户票券管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'userCoupon')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="用户优惠券号">
                    <a-input placeholder="请输入" v-decorator="['userCouponNo']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['account']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="优惠券id">
                    <a-input placeholder="请输入" v-decorator="['couponId']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="展示名称">
                    <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search(false)"></a-input>
                </a-form-item>
                <a-form-item label="优惠券类型">
                    <a-select allowClear placeholder="请选择" v-decorator="['suitType']" @select="search(false)">
                        <a-select-option value="1">门票</a-select-option>
                        <a-select-option value="2">餐饮</a-select-option>
                        <a-select-option value="3">零售</a-select-option>
                        <a-select-option value="4">课程</a-select-option>
                        <a-select-option value="10">租赁</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="优惠券状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['state']" @select="search(false)">
                        <a-select-option value="1">未使用</a-select-option>
                        <a-select-option value="2">已使用</a-select-option>
                        <a-select-option value="3">已禁用</a-select-option>
                        <a-select-option value="4">已过期</a-select-option>
                        <a-select-option value="5">已失效</a-select-option>
                        <a-select-option value="6">已锁定</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="优惠券来源">
                    <a-select allowClear placeholder="请选择" v-decorator="['sourceCode']" @select="search(false)">
                        <a-select-option value="ManagerSystem">后台操作</a-select-option>
                        <a-select-option value="GroupBuyGift">团购礼券兑换</a-select-option>
                        <a-select-option value="GiveActivity">赠品活动</a-select-option>
                        <a-select-option value="OwnerChangeGrant">活动票持有人更改</a-select-option>
                        <a-select-option value="AnewGrant">补开卡</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="获取时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['payTime']"
                        @change="search(false)"
                    />
                </a-form-item>
                <a-form-item label="使用时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['useTime']"
                        @change="search(false)"
                    />
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button :loading="searchLoading" @click="search(false)" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-card :bordered="false">
            <template slot="extra" v-if="getBtnByAuth('exportUserCoupon')">
                <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                <a-button @click="openExportModal">导出记录</a-button>
            </template>
            <a-table :scroll="{y: 560}" bordered :loading="searchLoading" :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                <span slot="suitType" slot-scope="suitType">{{['','门票','餐饮','零售','课程','','','','','','租赁'][suitType]}}</span>
                <span slot="userCouponState" slot-scope="userCouponState">{{['','未使用','已使用','已禁用','已过期','已失效','已锁定'][userCouponState]}}</span>
                <span slot="type" slot-scope="type">{{['','满减券','折扣券','兑换券'][type]}}</span>
                <span slot="sourceCode" slot-scope="sourceCode">{{sourceCode == 'ManagerSystem' || sourceCode == 'ManualDistribution' ? '后台操作' : sourceCode == 'GroupBuyGift' ? '团购礼券兑换' : sourceCode == 'GiveActivity' ? '赠品活动' : sourceCode == 'OwnerChangeGrant' ? '活动票持有人更改' : '补开卡'}}</span>
                <span slot="validStartTime" slot-scope="validStartTime,row">{{validStartTime.substr(0,10) + '至' + row.validEndTime.substr(0,10)}}</span>
                <span slot="empty" slot-scope="empty">{{empty ? empty : "-"}}</span>
                <span slot="action" slot-scope="a, row">
                    <template v-if="getBtnByAuth('userCouponForbidden')">
                        <a class="text-primary" v-if="row.userCouponState == 1" @click="couponState(row, true)">禁用</a>
                        <span v-else class="text-disabled">禁用</span>
                    </template>
                </span>
            </a-table>
        </a-card>
        <report-export-modal ref="reportExportModal" :exportType="34"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
    {
        title: "用户优惠券号",
        dataIndex: "userCouponNo"
    },
    {
        title: "会员手机号",
        dataIndex: "account",
        width: 130,
    },
    {
        title: "优惠券id",
        dataIndex: "couponId"
    },
    {
        title: "展示名称",
        dataIndex: "showName"
    },
    {
        title: "优惠券类型",
        dataIndex: "suitType",
        scopedSlots: { customRender: "suitType" }
    },
    {
        title: "优惠玩法",
        dataIndex: "type",
        scopedSlots: { customRender: "type" }
    },
    {
        title: "优惠券状态",
        dataIndex: "userCouponState",
        scopedSlots: { customRender: "userCouponState" }
    },
    {
        title: "优惠券来源",
        dataIndex: "sourceCode",
        scopedSlots: { customRender: "sourceCode" }
    },
    {
        title: "有效期",
        dataIndex: "validStartTime",
        scopedSlots: { customRender: "validStartTime" }
    },
    {
        title: "获取时间",
        dataIndex: "createTime",
    },
    {
        title: "使用时间",
        dataIndex: "useTime",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "关联订单号",
        dataIndex: "useTransNo",
        scopedSlots: { customRender: "empty" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "userCoupon",
        components: {},
        props: {},
        data() {
            return {
                options: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                phoneList: [],
                searchLoading: false
            };
        },
        computed: {
            ...mapGetters(["shopId","shopName"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            onClickGiveTicket(id) {
                this.$router.push({name: "sendDetail", query: {id: id}, params: {orderId: 0}})
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.pagination.pageSize = 20
                this.pagination.current = 1
                this.form.resetFields();
                this.getList()
            },
            search(isExport) {
                this.pagination.current = 1;
                this.getList(isExport);
            },

            // 获取购票订单列表
            getList(isExport) {
                if (this.searchLoading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.issueStartTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.issueEndTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined
                    const useTime = values['useTime'] ? values['useTime'] : []
                    values.usedStartTime = useTime.length > 0 ? useTime[0].format('YYYY-MM-DD') : undefined
                    values.usedEndTime = useTime.length > 0 ? useTime[1].format('YYYY-MM-DD') : undefined
                    delete values.payTime
                    delete values.useTime

                    this.searchLoading = true;
                    this.loading = true;
                    this.$api.member.userCouponList({
                        body: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                        })
                    }).then(res => {
                        this.searchLoading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                        if (isExport) {
                            this.exportExcel();
                        } else {
                            this.loading = false;
                        }
                    }).catch(err => {
                        this.searchLoading = false;
                        this.loading = false;
                    });
                });
            },

            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.issueStartTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined
                    values.issueEndTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined
                    const useTime = values['useTime'] ? values['useTime'] : []
                    values.usedStartTime = useTime.length > 0 ? useTime[0].format('YYYY-MM-DD') : undefined
                    values.usedEndTime = useTime.length > 0 ? useTime[1].format('YYYY-MM-DD') : undefined
                    delete values.payTime
                    delete values.useTime
                    this.loading = true
                    this.$api.member.userCouponExport({
                        body: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: this.pagination.total
                        })
                    })
                    .then(res => {
                        this.openExportModal();
                        this.loading = false;
                    }).catch(err => {
                        this.loading = false
                    })
                });
            },
            couponState(row) {
                this.$api.changeCode.couponState({
                    body: {
                        userCouponNo: row.userCouponNo,
                        userId: row.userId,
                        phone: row.account, 
                        shopId: this.shopId,
                        shopName: this.shopName,
                        platformId: -1,
                    }
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                })
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        created() {},
        mounted() {
            setTimeout(() => {
                this.getList()
            }, 500);
        }
    };
</script>
<style lang="scss">
</style>